<template>
  <CCard>
    <CCardHeader>
      <b>Dev Tools</b>
    </CCardHeader>
    <CCardBody>
      <CRow align-horizontal="start">
        <CCol>
          <RButton color="danger" @click="clearVuex">
            Reset Vuex State
          </RButton>
          <RButton color="danger" @click="clearLocalStorage">
            Clear Local Storage
          </RButton>
          <RButton color="danger" @click="clearAuthentication">
            Clear Authentication
          </RButton>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <RButton :loading="loadingAccount" color="info" @click="fetchAccount">
            Refresh Account
          </RButton>
          <RButton :loading="loadingCompanies" color="info" @click="fetchCompanies">
            Refresh Companies
          </RButton>
          <RButton :loading="loadingRegions" color="info" @click="fetchRegions">
            Refresh Regions
          </RButton>
          <RButton :loading="loadingProducts" color="info" @click="fetchProducts">
            Refresh Products
          </RButton>
          <RButton :loading="loadingFeatures" color="info" @click="fetchFeatures">
            Refresh Features
          </RButton>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import { RButton } from '@/components/buttons'

export default {
  name: 'DevTools',
  components: {
    RButton
  },
  data () {
    return {
      loadingAccount: false,
      loadingCompanies: false,
      loadingRegions: false,
      loadingProducts: false,
      loadingFeatures: false
    }
  },
  methods: {
    clearVuex () {
      const exclude = ['auth']
      this.$store.dispatch('resetGlobalState', exclude)
    },
    clearLocalStorage () {
      localStorage.clear()
    },
    clearAuthentication () {
      this.$store.commit('auth/resetState')
    },
    async fetch (resource, action, params) {
      this[`loading${resource}`] = true
      await this.$store.dispatch(action, params)
      this[`loading${resource}`] = false
    },
    fetchAccount () {
      this.fetch('Account', 'auth/fetchAccount')
    },
    async fetchCompanies () {
      this.fetch('Companies', 'rooof/fetchCompanies')
    },
    async fetchRegions () {
      this.fetch('Regions', 'craigslist/fetchRegions')
    },
    async fetchProducts () {
      this.fetch('Products', 'rooof/fetchProducts')
    },
    async fetchFeatures () {
      this.fetch('Features', 'rooof/fetchFeatures')
    }
  }
}
</script>

<style lang="scss" scoped>
.row {
  padding-top: 15px;
  padding-bottom: 15px;
}
::v-deep button {
  margin-right: 5px;
  margin-left: 5px;
}
</style>
